import React, { Component } from 'react'
import datat from "../../assets/data.json";
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Loader from 'react-loader-spinner';
import * as MDICONS from '@material-ui/icons';
import { actionTypes } from 'redux-firestore';
import FolderCard from './FolderCard';

class AllFolders extends Component {

    /// TODO: correct this => bad setState() error!
    handleClear = () => {
        this.props.clearData();
    }

    componentDidMount() {
        // clear everything except Projects store
        this.handleClear();
    }

    render() {
        // console.log(this.props);

        const data = this.props.allProjects;
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }
        const {commons}=this.props;
        if (data) {
            if (data.length !== 0) {
                return (
                    <div className="row">
                        {data.map(FolderCard)}
                    </div>
                )
            } else {
                return (
                    <div>
                        <h5 style={textStyle}>You've no snagging folders <MDICONS.Folder /></h5>
                        <br></br>
                    </div>
                );
            }
        } else {
            return (
                <div>
                    <Loader
                        type="Grid"
                        color={this.props.themeColors.themeColor}
                        height={50}
                        width={50}
                    />
                    <br></br>
                    <p style={textStyle}>Getting all your snagging {commons.projects}</p>
                    <br></br>
                </div>
            )
        }
    }
}

const mapStateToProps = (state) => {
    // console.log(state.firebase.auth)
    return {
        auth: state.firebase.auth,
        themeColors: state.theme,
        allProjects: state.firestore.ordered.Projects,
        commons: state.commons,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        // DOCS: https://github.com/prescottprue/redux-firestore/issues/114
        clearData: () => dispatch({ type: actionTypes.CLEAR_DATA, preserve: { data: ['Projects', 'Company','CompanyBriefings','Notifications'], ordered: ['Projects', 'Company','CompanyBriefings','Notifications'] } }),
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect((props) => [
        {
            collection: 'Projects',
            where: [['accessList', 'array-contains', props.auth.uid]]
        }
    ])
)(AllFolders);